import request from "../../../app/api/requests";



export function sendFeedbackData(form: FormData) {
    return (
        request.post('/Feedback/', form, {
            headers: {
              'Content-Type': 'multipart/form-data',
          },
          })
    )
}